import { Divider } from '@mui/material';
import { gradientDividerSx } from './SuggestedDocumentReference.styles';

const GradientDivider = () => <Divider sx={gradientDividerSx} />;

export default GradientDivider;
